import React, { useEffect, useRef } from "react";
import { ASSETS_ROUTES } from "../../lib/common/constants";

type TModalProps = {
    onCloseHandler: () => void;
    title: string;
    fullScreen?: boolean;
} & React.PropsWithChildren;

export const Modal = (props: TModalProps) => {
    const refComponent = useRef<HTMLDivElement>(null);
    const windowGlobal = window as any;
    const fullScreenModal = props.fullScreen ? "modal-fullscreen" : "modal-fullscreen-sm-down";

    const handleModalClose = () => {
        if (!refComponent.current) {
            setTimeout(() => {
                handleModalClose();
            }, 100);
            return;
        }
        if (windowGlobal.wwg_genericModal) {
            //TODO: change to window.bootstrap.Modal.getInstance(refWelcomeLabModal.current)?.hide(); when we update to bootstrap 5.2
            windowGlobal.wwg_genericModal.hide();
            props.onCloseHandler();
        }
    };

    useEffect(() => {
        const _showModal = () => {
            if (!refComponent.current) {
                setTimeout(() => {
                    _showModal();
                }, 500);
                return;
            }

            windowGlobal.wwg_genericModal = new window.bootstrap.Modal(refComponent.current, { backdrop: "static" });

            windowGlobal.wwg_genericModal.show();
        };

        _showModal();

        return () => {
            if (windowGlobal.wwg_genericModal) {
                windowGlobal.wwg_genericModal.hide();
                delete windowGlobal.wwg_genericModal;
            }
        };
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="modal fade" tabIndex={-1} ref={refComponent}>
            <div className={`modal-dialog modal-dialog-centered ${fullScreenModal}`}>
                <div className="modal-content">
                    <div className="modal-header bg-dark text-white border-0 px-3 py-2">
                        <div className="d-flex align-items-center justify-content-between w-100 gap-3 overflow-hidden">
                            <img src={ASSETS_ROUTES.IMGS.logo} alt="logo of winwingo" className="img-fluid flex-shrink-0 modal-logo" />
                            <h5 className="modal-title mb-0 text-center text-truncate flex-grow-1">{props.title}</h5>
                            <button
                                type="button"
                                className="btn-close text-white d-inline-flex align-items-center justify-content-center flex-shrink-0 p-0 me-2"
                                style={{ width: "1.5rem", height: "1.5rem" }}
                                aria-label="Close"
                                onClick={handleModalClose}
                            >
                                <i className="fa-close fa-solid" />
                            </button>
                        </div>
                    </div>

                    {props.children}
                    <div className="modal-footer bg-dark border-0 text-white">
                        <div className="w-100 text-center">
                            <img src={ASSETS_ROUTES.IMGS.logo} alt="logo of winwingo" className="img-fluid modal-logo" />
                        </div>
                        <div className="w-100 text-center">
                            <small style={{ fontSize: "10px" }}>© 2026 WinWinGo. All rights reserved.</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
